module.exports = __webpack_public_path__ + "cf3134102a98a525dcf1dd79231c6c52.svg";